<template></template>
<script>
    import BlogPostCardsComponent from '../../components/pagesbuilder/dynamic-components/BlogPostCardsComponent.vue';
    import PreviewComponent from "./PreviewComponent";

    export default {
        name: "PreviewBlogPostCardsComponent",
        mixins: [
            PreviewComponent,
            BlogPostCardsComponent
        ],
        methods: {
            seeAllClicked () {
                document.location.href = "/blog";
            },
            loadMoreClicked () {
                this.page += 1;
                this.setRows({value: this.myData.rows + 1});                
            },
            createCardListeners () {
                let cards = this.componentNode.querySelectorAll(".js-blog-card");

                for (let index in cards) {
                    if (!cards.hasOwnProperty(index)) {
                        continue;
                    }

                    let card = cards[index];

                    card.addEventListener("click", () => {
                        window.open("/blog/" + card.getAttribute("data-slug"), "_self");
                    })
                }
            },
        },
        watch:{
            "myData.rows": {
                handler (newVal, oldVal){
                    // console.log("4 rows newVal, oldVal: " , newVal, oldVal  , this.myId)
                    if (newVal !== oldVal && !this.renderInProgress) {
                        this.loadPostsPage();
                    }

                }
            },
        }
    }
</script>
